<template>
  <div class="database-selection">
    <loading-block v-if="!loaded"></loading-block>
    <v-card v-else elevation="0" class="px-4 pb-10">
      <v-card-title> </v-card-title>
      <v-card-text>
        <!-- THC/CBD -->
        <v-row class="d-flex flex-column">
          <v-row>
            <v-col>
              <h4 class="font-weight-bold">THC/CBD</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="ml-0 pl-0"
              cols="12"
              md="3"
              lg="3"
              sm="12"
              v-for="item in thcCbd"
              :key="item.title"
            >
              <v-checkbox
                :label="item.title"
                v-model="selectionData.sync_thc_cbd"
                class="font-weight-medium text-left"
              ></v-checkbox>
              <div class="d-flex justify-center align-center">
                <p>POS</p>
                <v-switch
                  :input-value="selectionData[item.value] === 'pmd'"
                  @change="changeVal(item.value)"
                  color="success"
                  class="mb-0 mt-2 py-0 mx-5"
                  inset
                ></v-switch>
                <p>Budler</p>
              </div>
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="selectedLocation.id === undefined"
          depressed
          color="primary"
          @click="importPos()"
          >SYNC PRODUCTS</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DatabaseSelectionAPI } from '@/clients/database/database.selection.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data: () => ({
    loaded: false,
    selectionData: {
      location_id: null,
      thc_cbd: 'pos',
      sync_thc_cbd: false
    },
    is404: false,
    thcCbd: [{ title: 'THC/CBD', value: 'thc_cbd' }]
  }),
  computed: {
    ...mapGetters({
      selectedLocation: 'location/selected',
      vg_selectedLocationEmail: 'location/selectedLocationEmail'
    })
  },
  async created() {
    try {
      this.loaded = false
      await this.databaseSelectionData()
      this.loaded = true
    } catch (err) {
      this.loaded = true
    }
  },
  methods: {
    async databaseSelectionData() {
      try {
        if (this.selectedLocation.id !== undefined) {
          const { data } = await DatabaseSelectionAPI.fetch(
            this.selectedLocation.id
          )
          this.selectionData['thc_cbd'] = data.payload['thc_cbd']
        }

        this.is404 = false
      } catch (err) {
        this.is404 = true
      }
    },
    changeVal(val) {
      const currentVal = this.selectionData[val]
      this.selectionData[val] = currentVal === 'pmd' ? 'pos' : 'pmd'
    },
    importPos() {
      let data = { ...this.selectionData }
      if (this.is404) {
        this.$swal(
          'Failed!',
          'Cannot Import POS Please Save Before Importing',
          'error'
        )
      } else {
        this.spinner(true)
        if (!data.location_id) {
          data.location_id = this.selectedLocation.id
        }
        let promise = DatabaseSelectionAPI.partialSync(data)

        let isPending = true

        setTimeout(() => {
          if (isPending) {
            this.spinner(false)
            this.$swal(
              'Success!',
              `We will send a confirmation email ${
                this.vg_selectedLocationEmail
                  ? `to ${this.vg_selectedLocationEmail} `
                  : ''
              }when your sync has been completed. This could take up to an hour depending on your POS system.`,
              'success'
            )
          }
        }, 4000)

        promise
          .then(result => {
            this.snackbar({
              text:
                (result.status === 200
                  ? result.data.msg
                  : result.response.data.errors
                  ? result.response.data.errors[0]
                  : result.response.data.msg) || 'Something Went Wrong',
              open: true,
              color: result.status === 200 ? 'success' : 'error'
            })
          })
          .catch(err => {
            console.log('err.response', err.response)
            this.snackbar({
              text: err.response.data.errors
                ? err.response.data.errors[0]
                : err.response.data.msg
                ? err.response.data.msg
                : err.response.statusText,
              open: true,
              color: 'error'
            })
          })
          .finally(() => {
            console.log('from Finally')
            isPending = false
            this.spinner(false)
          })
      }
    }
  }
}
</script>

<style>
.database-selection .v-input__slot {
  margin: 0;
}
</style>
